import React from "react";
import { withStyles } from "@material-ui/styles";
import { debounce } from "lodash";

import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import CustomInput from "../CustomInput";

const styles = {
  container: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    height: "50px",
  },
  inputContainer: {
    width: "50px",
    display: "inline-block",
  },
};

const TablePaginationActions = (props) => {
  const { classes } = props;
  const { count, page, rowsPerPage, onChangePage } = props;
  const [tempInputValue, setTempInputValue] = React.useState();

  const handleInputChange = (e) => {
    const pageNumber = parseInt(e.target.value);
    setTempInputValue(pageNumber || "");
    if (pageNumber) debouncedInputChange(pageNumber);
  };

  const debouncedInputChange = React.useCallback(
    debounce((pageNumber) => {
      onChangePage(pageNumber);
      setTempInputValue();
    }, 1000),
    []
  );

  return (
    <Box className={classes.container}>
      <IconButton
        onClick={() => onChangePage(0)}
        disabled={page === 0}
        aria-label="first page"
      >
        {<FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={() => onChangePage(page - 1)}
        disabled={page === 0}
        aria-label="previous page"
      >
        {<KeyboardArrowLeft />}
      </IconButton>
      <Box className={classes.inputContainer}>
        <CustomInput
          name="page"
          value={tempInputValue !== undefined ? tempInputValue : page}
          onChange={handleInputChange}
        />
      </Box>
      <IconButton
        onClick={() => onChangePage(page + 1)}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {<KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={() =>
          onChangePage(Math.max(0, Math.ceil(count / rowsPerPage) - 1))
        }
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {<LastPageIcon />}
      </IconButton>
    </Box>
  );
};

export default withStyles(styles)(TablePaginationActions);
